import { JSX } from 'react';
import { useLocation } from 'react-router-dom';
import { Background } from './Background';
import { Animation } from './Animation';

interface IProps {
    message?: string;
}

interface IState {
    title?: string;
}

// CSS in the app is loaded manually because of rtl / ltr
// if we have error during auth / initial endpoint requests we
// don't have yet css loaded, but we need to show players UI with message
const css = `
    .message {
        display: block;
        margin: 10vh auto 30px;
        max-width: 50vw;
        text-align: center;
    }

    .title {
        font-size: 1.4em;
        font-weight: 700;
        margin: 0 0 15px;
    }

    .background {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: -1;
    }

    @keyframes float {
        0% {
            transform: translateY(0);
        }

        50% {
            transform: translateY(70vh);
        }

        100% {
            transform: translateY(0);
        }
    }

    .image {
        display: block;
        margin: 0 auto;
        transform: translateY(0);
        animation: float 30s ease-in-out infinite;
        max-width: 24vw;
    }

    @media (min-width: 800px) {
        max-width: 12vw;
    }

    .st0 {
        fill: #8e8e8e;
    }

    .st1 {
        fill: #b3b3b3;
    }

    .st2 {
        fill: #eaeaea;
    }

    .st3 {
        opacity: 0.8;
        fill: #ff7153;
    }

    .st4 {
        fill: #ff7153;
    }

    .st5 {
        fill: #ffa18e;
    }

    .st6 {
        opacity: 0.51;
        fill: #fff;
    }

    .st7 {
        opacity: 0.6;
    }

    .st8 {
        fill: #fff;
    }

    .st9 {
        opacity: 0.43;
        fill: #fff;
    }

    .st10 {
        fill: #493a38;
    }
`;

export const ErrorPage = (props: IProps): JSX.Element => {
    const location = useLocation();

    return (
        <div>
            <style>{css}</style>
            <div className="message">
                <div className="title">
                    {(location?.state as IState)?.title ??
                        props.message ??
                        'Ups! Something went wrong.'}
                </div>
            </div>
            <Animation />
            <Background />
        </div>
    );
};
